import { css } from 'lit';
export default css `
  p {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: -0.2px;
  }
`;
//# sourceMappingURL=styles.js.map